import { Component, inject, OnInit } from '@angular/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NZ_MODAL_DATA } from 'ng-zorro-antd/modal';

@Component({
  template: `
    <div class="modal__download">
      <div class="modal__content">
        Processing of your request was successful.
        <div>File size is: {{ fileSize }} kB</div>
      </div>
      <div class="modal__actions">
        <button
          nz-button
          id="modal__download__actions__download"
          class="modal__actions--primary modal__actions--success"
          (click)="onDownload()"
        >
          <i
            nz-icon
            nzType="download"
          ></i>
          Download .{{ format }}
        </button>
      </div>
    </div>
  `,
  styles: [
    `
      .modal__actions {
        margin-top: 20px;
      }
    `
  ],
  imports: [NzButtonModule, NzIconModule],
  standalone: true
})
export class DownloadModalComponent implements OnInit {
  public fileSize = 0;
  public format?: string;
  private modalData: DownloadModalComponent = inject(NZ_MODAL_DATA);

  public onDownload: () => void = () => {};

  ngOnInit() {
    const { format, fileSize, onDownload } = this.modalData;
    this.format = format;
    this.fileSize = fileSize;
    this.onDownload = onDownload;
  }
}
